var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{attrs:{"id":"site-header"}},[_c('j-header')],1),_c('main',[_vm._t("default")],2),_c('footer',[_c('j-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }